import React, { Component } from 'react';

import { Badge, Modal } from 'react-bootstrap';

import CommonButton from './CommonButton';

import * as constants from '../../config/constants/AppConstants';

const UI_SIZE = constants.AppSettings.UI_SIZE;
class CommonConfirmModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fadingOut: false, 
        }
    }

    callback = (bool, action) => {
        const { onCallback, Action } = this.props;
      
        if (!onCallback) return;
      
        const callbackPayload = {
            mode: action ? Action.Modal.mode : '',
            show: bool,
            action: action
        };
      
        this.setState({ fadingOut: true }, () => {
            setTimeout(() => {
                onCallback(callbackPayload);
                this.setState({ fadingOut: false });
            }, 300); 
        });
    };      

    render = () => {

        let props = this.props;

        let { Action, Deletes } = props;

        let { mode, show } = Action.Modal;

        let ModalProps = constants.ModalProps[mode] || {};

        let { title = '', message = '', confirmButton = '', discard = '', size = 'sm', dismiss = false } = ModalProps;

        const { fadingOut } = this.state;

        let deleted = Deletes?.deletes?.length;

        return (
            <Modal 
                show={show && !fadingOut}
                centered 
                size={size}
                backdrop={dismiss ? true : "static"}
                keyboard={false}
                onHide={(e) => { this.callback(false, false) }}
                className={fadingOut ? "modal-fade-out" : ""}
                animation={true}
            >
                <Modal.Header className="custom-modal-header" closeButton>
                    <span className={`title-${UI_SIZE}`} style={{color: '#FFF'}}>{title}</span>
                </Modal.Header>

                <Modal.Body>
                    <span className="title-md text-muted">
                        {message}
                        {mode === 'confirm-delete' && deleted > 0 && (
                            <>
                                <Badge bg="danger" className="ms-2 me-2">{deleted}  รายการ</Badge>
                            </>
                        )}
                    </span>
                </Modal.Body>

                <Modal.Footer>
                    <CommonButton 
                        task={confirmButton} 
                        size="sm"
                        callback={(e) => this.callback(false, true) } 
                    />

                    {discard && (
                        <CommonButton 
                            task="discard" 
                            size="sm"
                            inlineClass="ms-0" 
                            callback={(e) => this.callback(false, false) } 
                        />
                    )}

                </Modal.Footer>
            </Modal>   
        )
    }
}

export default CommonConfirmModal;